import { ToastProvider } from "@/ds";
import { useObrasScreen } from "./use-obras-lista";
import { ObrasScreenView } from "./view-obras-lista";

function ObrasScreenLigada() {
  const vm = useObrasScreen();

  return <ObrasScreenView {...vm} />;
}

export function ObrasScreen() {
  return (
    <ToastProvider position="top-right">
      <ObrasScreenLigada />
    </ToastProvider>
  );
}

export type * from "./types-obras-lista";
